// Cibler le bouton pour ouvrir la popup
var openPopupBtn = document.getElementById('open-popup-btn');
// Cibler la popup et le bouton de fermeture
var popup = document.getElementById('my-popup');
var closePopupBtn = document.getElementById('close-popup-btn');

// Fonction pour ouvrir la popup
if (openPopupBtn) {
  openPopupBtn.addEventListener('click', function() {
    popup.style.display = 'flex'; // Affiche la popup
  });
}

// Fonction pour fermer la popup
if (closePopupBtn) {
  closePopupBtn.addEventListener('click', function() {
    popup.style.display = 'none'; // Ferme la popup
  });
}

// Fermer la popup si l'utilisateur clique en dehors de la boîte
popup.addEventListener('click', function(event) {
  if (event.target === popup) {
    popup.style.display = 'none'; // Ferme la popup
  }
});
